import * as yup from "yup";

export const addressSchema = yup.object({
  freeForm: yup.string().nullable(),
  streetNumber: yup.string().nullable(),
  streetName: yup.string().nullable(),
  streetNameSuffix: yup.string().nullable(),
  city: yup.string().nullable(),
  state: yup.string().nullable(),
  country: yup.string(),
});

/**
 * @typedef {Object} Address
 * @property {string} id
 * @property {string?} freeForm
 * @property {string?} streetNumber
 * @property {string?} streetName
 * @property {string?} streetNameSuffix
 * @property {string?} city
 * @property {string?} state
 */

/**
 * @link https://github.com/8x8/platform_admin_console_fe/blob/develop/packages/cm-addresses/src/service.js#L171
 *
 * @param {Address} address
 */
export const formatAddress = (address) => {
  if (!address) {
    return "";
  }

  const { freeForm, streetNumber, streetName, streetNameSuffix, city, state } =
    address;

  if (freeForm) {
    return freeForm;
  }

  let addressToString = "";

  if (streetNumber) {
    addressToString += streetNumber;
  }

  if (streetName) {
    addressToString += ` ${streetName}`;
  }

  if (streetNameSuffix) {
    addressToString += ` ${streetNameSuffix}`;
  }

  if (city) {
    addressToString += `, ${city}`;
  }

  if (state) {
    addressToString += `, ${state}`;
  }

  return addressToString.trim();
};
